<div class="postings">
  <!--
  <h3> Rendez vous ({{postings == null ? 0 : postings!.length}})</h3>
  <button *ngIf="(appointments == undefined || appointments.length === 0 )"
    class="cta-button"  mat-button (click)="openAppointmentDialog('', undefined);$event.stopPropagation()">
    Nouvelle<mat-icon>add</mat-icon>
  </button> -->

  @if (enableNew) {
    <button mat-button class="cta-button-buy" (click)="openPostingDialog(0);$event.stopPropagation()">
      Nouveau<mat-icon>add</mat-icon>
    </button>
  }

  @if (postings == undefined || postings.length === 0) {
    <h6>
      Aucun posting en cours
    </h6>
  }

  @if (!(postings == undefined || postings.length === 0 )) {
    <div class="posting-list">
      @for (posting of postings; track posting; let i = $index) {
        <div class="posting">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b>
            <h4 *ngIf="objectSource===ObjectSource.DEALER"> {{posting.carMake}} {{posting.carModel}} {{posting.carVersion}} </h4> -->
            <h5 class="summary-details"><mat-icon>forum</mat-icon> N° {{posting.postingId}} - {{posting.type}} </h5>
            <h6 class="summary-details"><mat-icon>person</mat-icon> ID post: <b>{{posting.postId}}</b></h6>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Statut: <b>{{posting.status}}</b></h6>
          </div>
          <div class="content">
            <!-- <h4> {{moneyFormat(""+posting.proposedPrice.amount)}} {{posting.proposedPrice.currency}}</h4>  -->
            <h5 class="status">{{posting.status}}</h5>
            <h6> Date post: {{dateFormat(posting.postCreatedDate)}}</h6>
            <h6> Créé le: {{dateFormat(posting.created)}}</h6>
            <h6> Message: {{posting.message}}</h6>
            <!--
            <span *ngIf ="posting.modification !== null">
              <h5> Modif:</h5>
              <h6 > {{posting.modification!.proposedPrice.amount}} {{posting.modification!.proposedPrice.currency}}
                / {{dateFormat(posting.modification!.appointmentDate)}} / {{posting.modification!.comment}} /
              {{posting.modification!.status}}</h6>
            </span>
            <span *ngIf ="posting.status === PostingStatus.COMPLETED">
              <h5> Vente:</h5>
              <h6> {{posting.completedPrice.amount}} {{posting.completedPrice.currency}}
              / {{dateFormat(posting.completedDate)}} / {{posting.completedNotes}} </h6>
            </span> -->
            <!--
            <h6> Date création: {{dateFormat(posting.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(posting.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              @for (actionItem of postingActionItems; track actionItem; let j = $index) {
                <div>
                  @if (posting.actions?.includes(actionItem.action)) {
                    <button
                      class="simple-button"  mat-button (click)="executePostingAction(posting, actionItem.action);$event.stopPropagation()">
                      {{ actionItem.title }} <mat-icon> {{ actionItem.icon }}</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
            <!--
            <div class="action-buttons">
              <button *ngIf="(posting.status !== PostingStatus.CANCELLED)"
                class="simple-button"  mat-button (click)="updatePostingStatus(posting.id, PostingStatus.CANCELLED);$event.stopPropagation()">
                Annuler <mat-icon>cancel</mat-icon>
              </button>
              <button *ngIf="(posting.status === PostingStatus.SENT)"
                class="simple-button"  mat-button (click)="openPostingDialog(posting.id, false);$event.stopPropagation()">
                Editer <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="(posting.status === PostingStatus.ACCEPTED)"
                class="simple-button"  mat-button (click)="openPostingDialog(posting.id, true);$event.stopPropagation()">
                Changer date <mat-icon>calendar</mat-icon>
              </button>
              <button *ngIf="(posting.status === PostingStatus.SENT)"
                class="cta-button-buy"  mat-button (click)="updatePostingStatus(posting.id, PostingStatus.ACCEPTED);$event.stopPropagation()">
                Accepter <mat-icon>accept</mat-icon>
              </button>
            </div>  -->
          </div>
        </div>
      }
    </div>
  }
</div>